import actionTypes from 'redux/actions/actionTypes'
import { parse } from 'qs'
import decodeJWT from 'helpers/decodeJWT'

const defaultState = {
	fromLTI: '0',
	referer: '',
	lerr: '0',
	isMsft: '',
	teamsDesktopApp: '',
	lcsbt: '',
	from_google_slides: '0',
	sk: '',
	returnUrl: '',
	cancelUrl: '',
	q: '',
	presentationId: '',
	authId: '',
	lessonTypeFilter: '',
	presentationOrigin: '',
	navigationMenuView: '',
	picker: '',
	isSessionPreview: '0',
	pincode: '',
	filters: [],
	customSlideId: '',
}

function updateLoginParams(state, action) {
	const params = parse(action.locationSearch.substr(1))
	const newState = {...state}
	newState.fromLTI = params.fromLTI || '0'
	newState.referer = params.referer
	newState.lerr = params.lerr
	newState.from_google_slides = params.from_google_slides || '0'
	newState.lcsbt = params.lcsbt ? params.lcsbt : ''
	newState.isMsft = params.iframe ? params.iframe : ''	//TODO: It needs a refactor for change iframe param to isMsft
	newState.teamsDesktopApp = params.teamsDesktopApp ? params.teamsDesktopApp : ''
	return newState
}

function updateSignupParams(state, action) {
	const params = parse(action.locationSearch.substr(1))
	const newState = {...state}
	newState.sk = params.sk ? params.sk : ''
	newState.from_google_slides = params.from_google_slides || '0'
	return newState
}

function updateGameParams(state, action) {
	const newState = updateCommonSearchParams(state, action)
	const jwt = decodeJWT(action.params.jwt)
	newState.presentationId = ''
	if (jwt.extra) {
		newState.presentationId = jwt.extra.presentationId || ''
		newState.presentationOrigin = jwt.extra.presentationOrigin || ''
		newState.customSlideId = jwt.extra.custom_slide_id || ''
	}
	return newState
}

function updateCancelUrlReturnUrlParams(state, action) {
	const newState = {...state}
	newState.returnUrl = action.params.returnUrl
	newState.cancelUrl = action.params.cancelUrl
	return newState
}

function updateSearchParams(state, action) {
	const newState = {
		...state,
		q: action.params.q,
		filters: action.params.filters,
		t: action.params.lessonTypeFilter,
	}
	return newState
}

function updateGoogleSlideParams(state, action) {
	return {...state, presentationId: action.params.presentation}
}

function updateAuthenticationParams(state, action) {
	const newState = {
		...state,
		authId: action.jwt,
	}
	return newState
}

function updateOeqParams(state, action) {
	return {
		...state,
		presentationOrigin: action.params.presentationOrigin || '',
	}
}

function updateNavigationMenuViewParams(state, action) {
	return {
		...state,
		navigationMenuView: action.navigationMenuView || '',
	}
}

function updateCommonSearchParams(state, action) {
	const newState = {
		...state,
		q: action.search && action.search.q || '',
		filters: action.search && action.search.filters || [],
		cancelUrl: action.params && action.params.cancelUrl || state.cancelUrl,
		returnUrl: action.params && action.params.returnUrl || state.returnUrl,
		presentationOrigin: '',
	}
	return newState
}

function updateInteractiveVideoParams(state, action) {
	const newState = {
		...updateCommonSearchParams(state, action),
		picker: action.search && action.search.picker || '',
		presentationOrigin: '',
	}
	return newState
}

function updateInteractiveVideoEditParams(state, action) {
	const newState = {
		...state,
		q: action.params.q || '',
		picker: action.params.picker || '',
		returnUrl: action.params.returnUrl || '',
		cancelUrl: action.params.cancelUrl || '',
	}
	return newState
}

function updateStudentJoinParams(state, action) {
	return {
		...state,
		isSessionPreview: action.params.isSessionPreview || '0',
		pincode: action.params.pincode || '',
	}
}

function updateSourceParams(state, action) {
	return {
		...state,
		referer: action.referer || defaultState.referer,
	}
}

const qsReducer = (state = defaultState, action) => {
	switch (action.type) {
		case actionTypes.LOGIN_INITIALIZE: {
			return updateLoginParams(state, action)
		}
		case actionTypes.SIGNUP_INITIALIZE:
			return updateSignupParams(state, action)
		case actionTypes.GAME_INITIALIZE_CREATION_TOOL:
		case actionTypes.GAME_INITIALIZE_STANDALONE:
		case actionTypes.FLIPGRID_INITIALIZE_STANDALONE:
		case actionTypes.GAME_UPDATE_CREATION_TOOL_SEARCH:
		case actionTypes.GAME_UPDATE_CREATION_TOOL:
			return updateGameParams(state, action)
		case actionTypes.STORE_SEARCH_ROUTE_INITIALIZE:
		case actionTypes.STORE_SEARCH_ROUTE_UPDATE:
			return updateSearchParams(state, action)
		case actionTypes.GOOGLE_SLIDES_INITIALIZE:
			return updateGoogleSlideParams(state, action)
		case actionTypes.FLOCABULARY_INITIALIZE_CREATION_TOOL:
		case actionTypes.FLOCABULARY_INITIALIZE_CREATION_TOOL_STANDALONE:
			return updateAuthenticationParams(state, action)
		case actionTypes.OEQ_INITIALIZE_CREATION_TOOL:
			return updateOeqParams(state, action)
		case actionTypes.FLIPGRID_CREATION_TOOL_INITIALIZE:
		case actionTypes.INTERACTIVE_VIDEO_INITIALIZE_CREATION_TOOL_BASE:
		case actionTypes.VIDEO_INITIALIZE_CREATION_TOOL_BASE:
		case actionTypes.VIDEO_STANDALONE_INITIALIZE_BASE:
			return updateCancelUrlReturnUrlParams(state, action)
		// @TODO: Remove MY_LIBRARY_ROUTE_FLAGS_UPDATE case when the feature flag NOTIFICATION_PREFERENCES is removed
		case actionTypes.MY_LIBRARY_INITIALIZE:
		case actionTypes.MY_LIBRARY_ROUTE_FLAGS_UPDATE:
			return updateNavigationMenuViewParams(state, action)
		case actionTypes.INTERACTIVE_VIDEO_INITIALIZE_CREATION_TOOL:
		case actionTypes.INTERACTIVE_VIDEO_UPDATE_CREATION_TOOL:
		case actionTypes.VIDEO_INITIALIZE_PICKER_ROUTE:
		case actionTypes.VIDEO_UPDATE_PICKER_ROUTE:
		case actionTypes.VIDEO_STANDALONE_INITIALIZE_PICKER_ROUTE:
		case actionTypes.VIDEO_STANDALONE_UPDATE_PICKER_ROUTE:
		case actionTypes.VIDEO_CREATION_OEQ_INITIALIZE:
		case actionTypes.VIDEO_CREATION_MCQ_INITIALIZE:
		case actionTypes.VIDEO_STANDALONE_OEQ_INITIALIZE:
		case actionTypes.VIDEO_STANDALONE_MCQ_INITIALIZE:
			return updateInteractiveVideoParams(state, action)
		case actionTypes.INTERACTIVE_VIDEO_INITIALIZE_CREATION_TOOL_EDIT:
		case actionTypes.VIDEO_INITIALIZE_EDIT_ROUTE:
		case actionTypes.VIDEO_STANDALONE_INITIALIZE_EDIT_ROUTE:
			return updateInteractiveVideoEditParams(state, action)
		case actionTypes.STUDENT_JOIN_INITIALIZE:
			return updateStudentJoinParams(state, action)
		case actionTypes.NEW_TERMS_AND_CONDITIONS_INITIALIZE:
			return updateSourceParams(state, action)
		case actionTypes.DRAW_IT_INITIALIZE_CREATION_TOOL:
		case actionTypes.DRAW_IT_UPDATE_CREATION_TOOL_SEARCH:
		case actionTypes.DRAW_IT_UPDATE_CREATION_TOOL:
		case actionTypes.DRAW_IT_INITIALIZE_STANDALONE:
		case actionTypes.MATCHING_PAIRS_UPDATE_CREATION_TOOL:
		case actionTypes.MATCHING_PAIRS_UPDATE_CREATION_TOOL_SEARCH:
		case actionTypes.MATCHING_PAIRS_CT_INITIALIZE_ROUTE:
		case actionTypes.MATCHING_PAIRS_INITIALIZE_STANDALONE:
			return updateCommonSearchParams(state, action)
		default:
			return state
	}
}

export default qsReducer
